<template>
  <div>
    <div class="bannerW">
      <el-image
        :src="require('@/assets/img/news.jpg')"
        fit="cover"
        class="banner"
      ></el-image>

      <AboutMenu
        :menu="[
          '公司动态',
          '文化活动',
          '视频新闻',
          '行业动态',
          '信息公示',
          '企业内刊',
        ]"
      />
      <div class="pageTitle" :class="{ titleEn: lang == 'en' }">
        <h2>公司动态</h2>
        <p>COMPANY NEWS</p>
      </div>

      <div class="titleBox" :class="{ titleEn: lang == 'en' }">
        <h2>砥砺奋进</h2>
        <p>SHEER ENDEAVOUR</p>
      </div>
      <div class="wrap"><Slide :lang="lang"/></div>
      <NewsList :lang="lang"/>

    </div>
  </div>
</template>

<script>
import AboutMenu from "./components/AboutMenu";
import NewsList from "./components/NewsList";
import Slide from "./components/Slide";
import VideoList from "./components/VideoList";
import BookList from "./components/BookList";

export default {
  data() {
    return {
      type: this.$route.query.type,
      lang: this.$global.lang,
    };
  },
  components: {
    AboutMenu,
    NewsList,
    Slide,
    VideoList,
    BookList,
  },
  mounted(){
    console.log(this.$route)
  }
};
</script>

<style lang="scss">
.en .aboutMenuBox .el-menu li:nth-child(n+2){display:none;}

</style>